import { gql } from '@apollo/client';

export default gql`
  mutation createNewCalibrationAudit($input: CreateCalibrationAuditInput!){
    createCalibrationAudit(input: $input) {
      id
      qaReview {
        id
      }
      auditable {
        __typename
        ... on QaReviewCalibrationAudit {
          id
        }
      }
    }
  }
`;
